import React, { Component } from 'react'
import { connect } from 'react-redux'
import GameSidebarCP from './GameSidebarCP'
import GameRegister from '../../common/GameRegister.js'

class GameFrameCP extends Component {
  constructor() {
    super()
    // this.state = {}
  }

  render() {
    if (
      !this.props.gameState
      || !this.props.gameState.game_type
      || !(this.props.gameState.game_type in GameRegister.GameTypes)
    ) return (<></>)
    // switch by gameType here
    let DisplayElement = GameRegister.getGameElements(this.props.gameState.game_type).gameEle
    return (
      <>
        <GameSidebarCP />
        <div className='game-contain' >
          <DisplayElement />
        </div>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    gameState: state.game.gameState
  }
}
  
const mapDispatchToProps = (dispatch) => {
  return {}
}
  
export default connect(mapStateToProps, mapDispatchToProps)(GameFrameCP)
